/* eslint-disable camelcase */
import moment from 'moment';
var Token = function Token(token) {
  return token && {
    type: (token == null ? void 0 : token.token_type) || (token == null ? void 0 : token.type),
    expires: (token == null ? void 0 : token.expires) || moment().add(token == null ? void 0 : token.expires_in, 's').toDate(),
    accessToken: (token == null ? void 0 : token.access_token) || (token == null ? void 0 : token.accessToken),
    refreshToken: (token == null ? void 0 : token.refresh_token) || (token == null ? void 0 : token.refreshToken)
  };
};
Token.types = {
  Bearer: 'Bearer'
};
export default Token;